
import Header from "../components/header";
import Sidebar from "../components/sidebar";
import NewCustomerEdit from "../components/NewCustomerEdit";
import Footer from "../components/footer";

function NewCustomerEditViewPage() {
  return (
    <div>
    <div className='wrapper'>
      <Header />
      <Sidebar /> 
      <NewCustomerEdit /> 
    </div>
    <Footer /> 
  </div>
  // <Login/>
  );
}
export default NewCustomerEditViewPage;
